import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-chat-avatar',
  templateUrl: './chat-avatar.component.html',
  styleUrl: './chat-avatar.component.scss',
  imports: [NgTemplateOutlet, RouterLink],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ChatAvatarComponent implements OnInit, OnChanges {
  @Input() name?: string | null = null;
  @Input() avatarUrl?: string | null = null;
  @Input() link?: any[] | string | null = null;

  initials?: string;
  imageFailed = false;

  ngOnInit(): void {
    this.initials = this.getInitials();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']) {
      this.initials = this.getInitials();
    }
    if (changes['avatarUrl']) {
      this.imageFailed = false;
    }
  }

  onImageError(): void {
    this.imageFailed = true;
  }

  private getInitials(): string | undefined {
    return this.name
      ?.match(/\b(\w)/g)
      ?.slice(0, 2)
      .join('');
  }
}
